module.exports = new __parcel__URL__("period-filter-app-skeleton.tpl.eaf8d1c3.svg").toString();